import * as cpcUtil from "./cpcUtil";

export default class IntergratedPaginate {
  constructor() {
    this.setEvent();

    for (
      let i = 0;
      i < $('[data-wrap=another-deal-wrap-has-paging]').length;
      i += 1
    ) {
      const target = $(`[data-wrap=another-deal-wrap-has-paging]:eq(${i})`);
      this.render(target, 1);

      if (target[0].dataset.role === '_wrapRecommendDealContainer') {
        // 첫 6개 딜은 IO를 통해 전송, 나머지는 슬라이드 후에 전송
        const anchors = [...target[0].querySelectorAll('ul.deal-list > li > a')];
        cpcUtil.onFirstLoad(anchors.slice(0, 6), 'CPC_AI');
      }
    }
  }

  setEvent() {
    $('.another-deal-wrap').on(
      'click',
      '[data-role=intergratedPaginateButton]',
      this.onClickIntergratedPaginateButton
    );
  }

  clearEvent() {
    $('.another-deal-wrap').off(
      'click',
      '[data-role=intergratedPaginateButton]'
    );
  }

  onClickIntergratedPaginateButton = e => {
    if (this.bMoving) {
      return;
    }

    this.bMoving = true;

    const welClickedButton = $(e.currentTarget);
    const sButtonType = welClickedButton.attr('data-type');
    const welIntergrated = $(welClickedButton).closest('.another-deal-wrap');

    const welTargetDealList = welIntergrated.find('.deal-list');
    const nFullPage = parseInt(
      welIntergrated.find('[data-role=intergratedPaginateFullCount]').html(),
      10
    );
    const nCurrentPage = parseInt(
      welIntergrated.find('[data-role=intergratedPaginateNum]').html(),
      10
    );

    let nTargetPage = 0;

    if (sButtonType === 'next') {
      nTargetPage = nCurrentPage + 1;
    } else {
      nTargetPage = nCurrentPage - 1;
    }

    if (nTargetPage === 0) {
      nTargetPage = nFullPage;
    }
    if (nTargetPage > nFullPage) {
      nTargetPage = 1;
    }

    welTargetDealList.css(
      'transform',
      `translateX(-${(nTargetPage - 1) * 100}%)`
    );

    this.render(welIntergrated, nTargetPage);

    this.bMoving = false;

    if (welIntergrated[0].dataset.role !== '_wrapRecommendDealContainer') return;
    if (welTargetDealList[0].dataset[`slide${nTargetPage}`] === 'true') return;
    cpcUtil.onSlideEnd(
      [...welTargetDealList[0].querySelectorAll('li > a')],
      nTargetPage,
      6,
      'CPC_AI'
    );
  };

  render(welIntergrated, nCurrentNumber) {
    const welTargetDealList = welIntergrated.find('.deal-list');
    const nItemLength = welTargetDealList.find('li').length;
    let nItemPerPageLength = Math.round(
      welTargetDealList.outerWidth() / welTargetDealList.find('li').outerWidth()
    );

    if (nItemPerPageLength > 6) {
      nItemPerPageLength = 6;
    }

    const nFullCount = Math.ceil(nItemLength / nItemPerPageLength, 10);
    const sHtml = `<span data-role="intergratedPaginateNum">${nCurrentNumber}</span>/<span data-role="intergratedPaginateFullCount">${nFullCount}</span>`;
    welIntergrated.find('[data-role=intergratedPaginateNumber]').html(sHtml);
  }
}
